export enum DeliveryOrderRefundStatus {
    PENDING = 'pending',
    REJECTED = 'rejected',
    APPROVED = 'approved',
    DSP_APPROVED = 'dsp_approved',
}
